import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import { locationServices } from "../../Services";
import HsCodeRemarkService from "../../Services/HsCodeRemarkService";

export const AddHsCodeRemarks = ({
  setAddmodalshow,
  getData,
  countryList,
  setCountryList,
}) => {
  const [loader, setLoader] = useState(false);
  const history = useHistory();

  const initialValues = {
    country_id: "",
    hs_code: "",
    remarks: "",
  };

  const validationSchema = Yup.object().shape({
    country_id: Yup.string().required("Required"),
    hs_code: Yup.string().required("Required"),
    remarks: Yup.string().required("Required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      setLoader(true);
      HsCodeRemarkService.addHscoderemarks(values)
        .then((res) => {
          setLoader(false);
          if (res.status) {
            toast.success(res.msg);
            setAddmodalshow(false);
            getData();
          } else {
            toast.error(res.msg);
          }
        })
        .catch((error) => {
          setLoader(false);
          toast.error(error.message);
        });
    },
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = formik;

  const onCountryChange = (e) => {
    setFieldValue("country_id", e?.value || "");
  };

  return (
    <div className="row d-flex justify-content-center">
      <form className="control-form" autoComplete="off" onSubmit={handleSubmit}>
        {/* Country */}
        <div className="mb-3 row">
          <div className="col-12">
            <label className="form-label">Country</label>
            <Select
              styles={{
                valueContainer: (provided) => ({
                  ...provided,
                  height: "calc(2.15rem + 2px)",
                  overflowY: "visible",
                }),
                control: (provider) => ({
                  ...provider,
                  borderColor: touched.country_id
                    ? errors.country_id
                      ? "#f46a6a"
                      : "#34c38f"
                    : "#ced4da",
                  boxShadow: "0 0 0 0px #f46a6a",
                }),
                placeholder: (provider) => ({
                  ...provider,
                  color: "#a0b0ca",
                }),
              }}
              onChange={onCountryChange}
              options={countryList}
              placeholder="Select Country"
            />
            {touched.country_id && errors.country_id && (
              <div className="text-danger">{errors.country_id}</div>
            )}
          </div>
        </div>

        {/* HS Code */}
        <div className="row">
          <div className="mb-3 col-12">
            <label className="form-label">HS Code</label>
            <input
              type="number"
              name="hs_code"
              value={values.hs_code}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control ${
                touched.hs_code && errors.hs_code ? "is-invalid" : ""
              }`}
              placeholder="Enter HS Code"
            />
            {touched.hs_code && errors.hs_code && (
              <div className="text-danger">{errors.hs_code}</div>
            )}
          </div>

          {/* Remarks */}
          <div className="mb-3 col-12">
            <label className="form-label">Remarks</label>
            <input
              type="text"
              name="remarks"
              value={values.remarks}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control ${
                touched.remarks && errors.remarks ? "is-invalid" : ""
              }`}
              placeholder="Enter Remarks"
            />
            {touched.remarks && errors.remarks && (
              <div className="text-danger">{errors.remarks}</div>
            )}
          </div>
        </div>

        <div className="mt-3 mb-3 d-flex justify-content-between">
          <button
            className="btn btn-danger w-sm waves-effect waves-light"
            type="button"
            onClick={() => setAddmodalshow(false)}
          >
            Back
          </button>
          <button
            className="btn btn-primary w-sm waves-effect waves-light"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
      <Loader isShow={loader} />
    </div>
  );
};
